import React from 'react';
import { FaEnvelope, FaShieldAlt, FaFileContract } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <a href="/privacy-policy" className="footer-link">
            <FaShieldAlt className="icon" /> Privacy Policy
          </a>
          <a href="/terms" className="footer-link">
            <FaFileContract className="icon" /> Terms of Condition
          </a>
          {/* <a href="/promoter" className="footer-link">
            <FaUserTie className="icon" /> Promoter Portal
          </a> */}
          <a href="mailto:info@mantisgo.com" className="footer-link">
            <FaEnvelope className="icon" /> Contact Support
          </a>
        </div>
        <p className="footer-text">© {new Date().getFullYear()} Mantis. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
